// Static translation dictionary for the landing page.
// Keys are the Japanese source strings used throughout the templates.
export const translations = {
  // Navbar
  "ログイン": { jp: "ログイン", en: "Login", cn: "登入" },
  "人生目標": { jp: "人生目標", en: "Life Goals", cn: "人生目標" },
  "資産目標": { jp: "資産目標", en: "Asset Goals", cn: "資產目標" },
  "資産管理": { jp: "資産管理", en: "Asset Management", cn: "資產管理" },
  "無料から": { jp: "無料から", en: "Free", cn: "免費" },
  "魅力機能": { jp: "魅力機能", en: "Features", cn: "特色功能" },
  "ニュース": { jp: "ニュース", en: "News", cn: "最新消息" },
  "投稿": { jp: "投稿", en: "Posts", cn: "文章" },

  // Hero
  "Excel Hubは、成功者の行動を学び、目標を明確にし、助け合うコミュニティです。": {
    jp: "Excel Hubは、成功者の行動を学び、目標を明確にし、助け合うコミュニティです。",
    en: "Excel Hub is a community where you learn from the habits of successful people, clarify your goals, and support one another.",
    cn: "Excel Hub 是一個學習成功者行為、明確目標並互相幫助的社群。"
  },
  "あなたもこのコミュニティに参加し、人生を変える第一歩を踏み出しませんか？成功への鍵は、行動し続けることにあります！": {
    jp: "あなたもこのコミュニティに参加し、人生を変える第一歩を踏み出しませんか？成功への鍵は、行動し続けることにあります！",
    en: "Why not join this community and take the first step to transform your life? The key to success is to keep taking action!",
    cn: "你何不也加入這個社群，踏出改變人生的第一步？成功的關鍵在於持續行動！"
  },
  "参加しましょう！": { jp: "参加しましょう！", en: "Join us!", cn: "加入我們！" },

  // Home page sections
  "Excel Calは人生目標を達成するためツールです": {
    jp: "Excel Calは人生目標を達成するためツールです",
    en: "Excel Cal is a tool for achieving your life goals",
    cn: "Excel Cal 是達成人生目標的工具"
  },
  "目標を作成し、「自分の夢」と「他者へ貢献」をリンクする。今の生活や人生に満足していない方は、人生を変えるには、思考を変え、お金や時間の使い方を変えることからはじまります！": {
    jp: "目標を作成し、「自分の夢」と「他者へ貢献」をリンクする。今の生活や人生に満足していない方は、人生を変えるには、思考を変え、お金や時間の使い方を変えることからはじまります！",
    en: "Create goals and link \"your dreams\" with \"contributing to others.\" If you are not satisfied with your current life, changing it begins with changing how you think and how you spend your money and time!",
    cn: "設定目標，將「自己的夢想」與「為他人貢獻」連結起來。若你不滿意目前的生活，改變人生就要從改變思維、改變金錢與時間的使用方式開始！"
  },
  "目標のため資産形成": { jp: "目標のため資産形成", en: "Building assets to reach your goals", cn: "為目標而累積資產" },
  "価格プラン": { jp: "価格プラン", en: "Pricing Plans", cn: "價格方案" },
  "気軽くご利用から、豊富なカスタマイズまで対応させていただきます。": {
    jp: "気軽くご利用から、豊富なカスタマイズまで対応させていただきます。",
    en: "From casual use to rich customization, we have you covered.",
    cn: "從輕鬆入門到豐富的客製化，我們都能滿足您的需求。"
  },
  "多彩の機能": { jp: "多彩の機能", en: "Rich Features", cn: "豐富功能" },
  "機能説明": { jp: "機能説明", en: "Feature description", cn: "功能說明" },
  "すべて見る": { jp: "すべて見る", en: "View all", cn: "查看全部" },
  "よくある質問": { jp: "よくある質問", en: "Frequently Asked Questions", cn: "常見問題" },

  // AboutExpand
  "人生の目標を明確": { jp: "人生の目標を明確", en: "Clarify your life goals", cn: "明確人生目標" },
  "目標を目指し行動する": { jp: "目標を目指し行動する", en: "Take action toward your goals", cn: "朝目標行動" },
  "目標を達成させるアドバイス": { jp: "目標を達成させるアドバイス", en: "Advice to achieve your goals", cn: "達成目標的建議" },

  // FeatureList
  "いつでもどこでも資産状況の把握": { jp: "いつでもどこでも資産状況の把握", en: "Keep track of your assets anytime, anywhere", cn: "隨時隨地掌握資產狀況" },
  "金融資産の状況を常に最新の状態で把握できます。": {
    jp: "金融資産の状況を常に最新の状態で把握できます。",
    en: "Always stay up to date with the status of your financial assets.",
    cn: "隨時以最新狀態掌握金融資產的狀況。"
  },
  "問題リスクを見える化": { jp: "問題リスクを見える化", en: "Visualize risks", cn: "將風險可視化" },
  "投資先、資産クラス、市場環境などの要因をモニターリング、市場、クレジット、流動性リスク要因を識別し、評価する。": {
    jp: "投資先、資産クラス、市場環境などの要因をモニターリング、市場、クレジット、流動性リスク要因を識別し、評価する。",
    en: "Monitor factors such as investment targets, asset classes, and market conditions, and identify and assess market, credit, and liquidity risks.",
    cn: "監控投資標的、資產類別、市場環境等因素，並識別與評估市場、信用及流動性風險。"
  },
  "A.Iで運用アドバイス、助言": { jp: "A.Iで運用アドバイス、助言", en: "A.I.-powered investment advice", cn: "以 A.I. 提供投資建議" },
  "A.Iで、分散投資、長期的な視点、コストを意識、定期的な見直しと再バランスなど要素を分析し、適切な助言を提供する。": {
    jp: "A.Iで、分散投資、長期的な視点、コストを意識、定期的な見直しと再バランスなど要素を分析し、適切な助言を提供する。",
    en: "A.I. analyzes factors such as diversification, a long-term perspective, cost awareness, and periodic review and rebalancing to provide appropriate advice.",
    cn: "A.I. 分析分散投資、長期觀點、成本意識、定期檢視與再平衡等因素，提供適當的建議。"
  },

  // RequireList
  "資産状況の把握": { jp: "資産状況の把握", en: "Understanding your asset situation", cn: "掌握資產狀況" },
  "リスク分散の観点では、最も安全な投資方法は分散。しかし、分散された資産の状況をリアルタイムリーで把握するには沢山の課題がある。": {
    jp: "リスク分散の観点では、最も安全な投資方法は分散。しかし、分散された資産の状況をリアルタイムリーで把握するには沢山の課題がある。",
    en: "From a risk-diversification standpoint, the safest way to invest is to diversify. However, keeping track of diversified assets in real time comes with many challenges.",
    cn: "從風險分散的角度來看，最安全的投資方式就是分散。然而，要即時掌握分散後的資產狀況，仍有許多課題。"
  },
  "資産を一元管理し、リアルタイムでの更新": { jp: "資産を一元管理し、リアルタイムでの更新", en: "Manage all your assets in one place with real-time updates", cn: "集中管理資產並即時更新" },
  "金融資産の状況を常に最新の状態": { jp: "金融資産の状況を常に最新の状態", en: "Always keep financial assets up to date", cn: "金融資產狀況隨時保持最新" },
  "個人情報を登録せず、安全安心に利用可能": { jp: "個人情報を登録せず、安全安心に利用可能", en: "Use it safely without registering personal information", cn: "無需註冊個人資訊，安全安心使用" },
  "もっと…": { jp: "もっと…", en: "More…", cn: "更多…" },

  // FeatureTwo
  "変化を捉える、未来を読む": { jp: "変化を捉える、未来を読む", en: "Capture change, read the future", cn: "掌握變化，洞悉未來" },
  "市場情報を収集し、コミュニティーの意見を参考にし、変化を捉える。過去のデータやトレンドを分析し、未来の市場動向を予測する。": {
    jp: "市場情報を収集し、コミュニティーの意見を参考にし、変化を捉える。過去のデータやトレンドを分析し、未来の市場動向を予測する。",
    en: "Gather market information, take community opinions into account, and capture change. Analyze past data and trends to forecast future market movements.",
    cn: "收集市場資訊、參考社群意見並掌握變化；分析過往資料與趨勢，預測未來的市場動向。"
  },
  "運用アドバイス、助言": { jp: "運用アドバイス、助言", en: "Investment advice and guidance", cn: "投資建議與指導" },
  "分散投資、長期的な視点、コストを意識し、定期的な見直しと再バランス。自分自身のリスク許容度を理解する": {
    jp: "分散投資、長期的な視点、コストを意識し、定期的な見直しと再バランス。自分自身のリスク許容度を理解する",
    en: "Diversify, take a long-term view, be cost-conscious, and review and rebalance regularly. Understand your own risk tolerance.",
    cn: "分散投資、長期觀點、重視成本，並定期檢視與再平衡；了解自己的風險承受度。"
  },
  "専門家の助言": { jp: "専門家の助言", en: "Expert advice", cn: "專家建議" },
  "投資の世界は複雑であり、情報が常に更新されています。不確実性が高い分野に投資する場合や、自分で判断が難しい場合は、ファイナンシャルプランナーや資産運用の専門家に相談することも検討しましょう。": {
    jp: "投資の世界は複雑であり、情報が常に更新されています。不確実性が高い分野に投資する場合や、自分で判断が難しい場合は、ファイナンシャルプランナーや資産運用の専門家に相談することも検討しましょう。",
    en: "The investment world is complex and constantly evolving. When investing in highly uncertain areas or when you find it difficult to decide on your own, consider consulting a financial planner or an asset-management expert.",
    cn: "投資的世界相當複雜，資訊也不斷更新。當投資於高度不確定的領域，或難以自行判斷時，不妨考慮諮詢理財規劃師或資產管理的專家。"
  },

  // ProgressCircle
  "A.Iでリスク管理": { jp: "A.Iでリスク管理", en: "Risk management with A.I.", cn: "以 A.I. 管理風險" },
  "分散投資": { jp: "分散投資", en: "Diversification", cn: "分散投資" },
  "長期的な視点": { jp: "長期的な視点", en: "Long-term perspective", cn: "長期觀點" },
  "コスト最適化": { jp: "コスト最適化", en: "Cost optimization", cn: "成本最佳化" },
  "見直しと再バランス": { jp: "見直しと再バランス", en: "Review and rebalance", cn: "檢視與再平衡" },
  "機械学習、ビッグデータ分析": { jp: "機械学習、ビッグデータ分析", en: "Machine learning and big data analysis", cn: "機器學習與大數據分析" },
  "ストレステスト": { jp: "ストレステスト", en: "Stress testing", cn: "壓力測試" },
  "専門家でリスク管理": { jp: "専門家でリスク管理", en: "Risk management by experts", cn: "由專家管理風險" },
  "財務状況、投資目標": { jp: "財務状況、投資目標", en: "Financial situation and investment goals", cn: "財務狀況與投資目標" },
  "定量・定性的にリスク評価": { jp: "定量・定性的にリスク評価", en: "Quantitative and qualitative risk assessment", cn: "定量與定性風險評估" },
  "ストレステストとシナリオ分析": { jp: "ストレステストとシナリオ分析", en: "Stress testing and scenario analysis", cn: "壓力測試與情境分析" },
  "世界経済状況": { jp: "世界経済状況", en: "Global economic conditions", cn: "全球經濟狀況" },
  "市場環境変化への対応": { jp: "市場環境変化への対応", en: "Responding to changes in the market environment", cn: "因應市場環境變化" },
  "ポートフォリオの構成を適宜調整": { jp: "ポートフォリオの構成を適宜調整", en: "Adjust portfolio composition as appropriate", cn: "適時調整投資組合配置" },

  // Pricing
  "¥": { jp: "¥", en: "¥", cn: "¥" },
  "お申込": { jp: "お申込", en: "Apply", cn: "申請" },
  "開発中": { jp: "開発中", en: "In development", cn: "開發中" },
  "無料": { jp: "無料", en: "Free", cn: "免費" },
  "0": { jp: "0", en: "0", cn: "0" },
  "月": { jp: "月", en: "month", cn: "月" },
  "Pricing Thumb": { jp: "Pricing Thumb", en: "Pricing Thumb", cn: "Pricing Thumb" },
  "情報コミュニティ参加": { jp: "情報コミュニティ参加", en: "Join the information community", cn: "參加資訊社群" },
  "リアル経済情報": { jp: "リアル経済情報", en: "Real-world economic information", cn: "真實經濟資訊" },
  "ファイナンシャルプランニング": { jp: "ファイナンシャルプランニング", en: "Financial planning", cn: "財務規劃" },
  "モバイルAPP等の利用": { jp: "モバイルAPP等の利用", en: "Use of the mobile app and more", cn: "使用行動 App 等" },
  "個人": { jp: "個人", en: "Individual", cn: "個人" },
  "500": { jp: "500", en: "500", cn: "500" },
  "無料機能すべて": { jp: "無料機能すべて", en: "All free features", cn: "所有免費功能" },
  "他社の金融口座とAPI連携": { jp: "他社の金融口座とAPI連携", en: "API integration with other financial accounts", cn: "與其他金融帳戶進行 API 整合" },
  "広告なし": { jp: "広告なし", en: "No ads", cn: "無廣告" },
  "卓越": { jp: "卓越", en: "Premium", cn: "卓越" },
  "2,500": { jp: "2,500", en: "2,500", cn: "2,500" },
  "個人機能すべて": { jp: "個人機能すべて", en: "All individual features", cn: "所有個人功能" },
  "操作代行": { jp: "操作代行", en: "Operation on your behalf", cn: "代為操作" },
  "メール・チャットサポート": { jp: "メール・チャットサポート", en: "Email and chat support", cn: "電子郵件與線上客服支援" },
  "専門家助言": { jp: "専門家助言", en: "Expert advice", cn: "專家建議" },
  "カスタマイズ": { jp: "カスタマイズ", en: "Custom", cn: "客製化" },
  "相談": { jp: "相談", en: "Consultation", cn: "諮詢" },
  "月/年": { jp: "月/年", en: "month/year", cn: "月/年" },
  "「卓越」機能すべて": { jp: "「卓越」機能すべて", en: "All \"Premium\" features", cn: "所有「卓越」功能" },
  "電話サポート": { jp: "電話サポート", en: "Phone support", cn: "電話支援" },
  "グローバル資産運用": { jp: "グローバル資産運用", en: "Global asset management", cn: "全球資產管理" },
  "その他の資産運用サービス": { jp: "その他の資産運用サービス", en: "Other asset management services", cn: "其他資產管理服務" },

  // Accordion
  "個人情報を入力する必要はありますか？": { jp: "個人情報を入力する必要はありますか？", en: "Do I need to enter personal information?", cn: "需要輸入個人資訊嗎？" },
  "excel.jp は、単なる人生目標を設定、遂行をサポートするためのツールです。個人情報の入力は必要ありません。また、ユーザを特定するための情報は一切収集しておりません。但し、ユーザを識別、システムから情報を提供するために、Emailアドレスを使用しています。": {
    jp: "excel.jp は、単なる人生目標を設定、遂行をサポートするためのツールです。個人情報の入力は必要ありません。また、ユーザを特定するための情報は一切収集しておりません。但し、ユーザを識別、システムから情報を提供するために、Emailアドレスを使用しています。",
    en: "excel.jp is simply a tool to support setting and pursuing your life goals. No personal information is required. We do not collect any information to identify users. However, we use your email address to identify you and provide information from the system.",
    cn: "excel.jp 只是支援設定並達成人生目標的工具，不需要輸入個人資訊。我們不會收集任何用於識別使用者的資訊。不過，為了識別使用者並由系統提供資訊，我們會使用電子郵件地址。"
  },
  "入力された内容が第三者に漏洩することはありますか？": { jp: "入力された内容が第三者に漏洩することはありますか？", en: "Could the content I enter be leaked to a third party?", cn: "輸入的內容會洩漏給第三方嗎？" },
  "excel.jpは、ユーザを特定する行為を一切しませんので、入力された内容が第三者に漏洩すること心配がありません。また、ユーザの情報は、ユーザの許可なしに第三者に提供することはありません。": {
    jp: "excel.jpは、ユーザを特定する行為を一切しませんので、入力された内容が第三者に漏洩すること心配がありません。また、ユーザの情報は、ユーザの許可なしに第三者に提供することはありません。",
    en: "excel.jp never attempts to identify users, so you don't need to worry about the content you enter being leaked to third parties. Also, your information will never be provided to third parties without your permission.",
    cn: "excel.jp 完全不會識別使用者，因此無須擔心輸入的內容外洩給第三方。此外，未經使用者同意，我們不會將使用者資訊提供給第三方。"
  },
  "金融商品などの販売、取引しますか？": { jp: "金融商品などの販売、取引しますか？", en: "Do you sell or trade financial products?", cn: "你們會銷售或交易金融商品嗎？" },
  "excel.jpは、ツールの提供を目的としており、金融商品などの販売、取引は行っておりません。また、ユーザに対して金融商品などの直接勧誘を行うことはありません。": {
    jp: "excel.jpは、ツールの提供を目的としており、金融商品などの販売、取引は行っておりません。また、ユーザに対して金融商品などの直接勧誘を行うことはありません。",
    en: "excel.jp's purpose is to provide a tool; we do not sell or trade financial products. Nor do we directly solicit financial products from users.",
    cn: "excel.jp 的目標是提供工具，不會銷售或交易金融商品，也不會直接向使用者推銷金融商品。"
  },
  "銀行口座などの金融情報を入力する必要はありますか？": { jp: "銀行口座などの金融情報を入力する必要はありますか？", en: "Do I need to enter financial information such as bank account details?", cn: "需要輸入銀行帳戶等金融資訊嗎？" },
  "煩雑な入力を避けるため、銀行口座とAPI連携することができますが、必須ではありません。ユーザが自由に設定できる項目です。": {
    jp: "煩雑な入力を避けるため、銀行口座とAPI連携することができますが、必須ではありません。ユーザが自由に設定できる項目です。",
    en: "To avoid cumbersome data entry, you can link your bank account via API, but it is not required. This is an option you can set freely.",
    cn: "為了避免繁瑣的輸入，您可以透過 API 連結銀行帳戶，但這並非必要，是可依使用者自由設定的項目。"
  },

  // AccordionTwo
  "このサイトのコンセプトは？": { jp: "このサイトのコンセプトは？", en: "What is the concept of this site?", cn: "這個網站的概念是什麼？" },
  "卓越したレベルで成功を達成し続けている人たちが共通して語るのは、「自分で決めたルールを守ること」の大切さです。「ルール」に従えば、望む結果が手に入るのです。生まれや性格、年齢はほとんど関係なく、誰がやっても、そのルールに従えば結果が出る、それが「達成の科学」です。": {
    jp: "卓越したレベルで成功を達成し続けている人たちが共通して語るのは、「自分で決めたルールを守ること」の大切さです。「ルール」に従えば、望む結果が手に入るのです。生まれや性格、年齢はほとんど関係なく、誰がやっても、そのルールに従えば結果が出る、それが「達成の科学」です。",
    en: "People who keep achieving success at an exceptional level all talk about the importance of \"following the rules you set for yourself.\" If you follow the \"rules,\" you'll get the results you want. Your background, personality, and age hardly matter — anyone who follows those rules will see results. That is the \"science of achievement.\"",
    cn: "持續以卓越水準取得成功的人們共同強調「遵守自己訂下的規則」的重要性。只要遵循「規則」，就能獲得想要的結果。出身、性格與年齡幾乎無關，任何人只要遵循規則都能看到成果，這就是「達成的科學」。"
  },
  "目標を定期的見直しすることは必要ですか？": { jp: "目標を定期的見直しすることは必要ですか？", en: "Is it necessary to review my goals regularly?", cn: "需要定期檢視目標嗎？" },
  "はい。目標が複数設定もできますし、目標の達成度合いを確認することが必要です。また、遂行途中も変更があるかもしれませんので、定期的見直しをお勧めします。": {
    jp: "はい。目標が複数設定もできますし、目標の達成度合いを確認することが必要です。また、遂行途中も変更があるかもしれませんので、定期的見直しをお勧めします。",
    en: "Yes. You can set multiple goals, and it's important to check your progress toward them. Plans may also change along the way, so we recommend reviewing them regularly.",
    cn: "是的。您可以設定多個目標，也需要確認目標的達成程度。此外，執行過程中可能會有變動，因此建議定期檢視。"
  },
  "面倒くさいな管理は本当に必要ですか？": { jp: "面倒くさいな管理は本当に必要ですか？", en: "Is tedious management really necessary?", cn: "繁瑣的管理真的有必要嗎？" },
  "必須ではないですが、目標を達成するためには、管理監督があった方が、より効率。管理をしないと、目標達成の確率が下がります。目標を達成するためには、管理・監督が必須と言っても過言ではありません。": {
    jp: "必須ではないですが、目標を達成するためには、管理監督があった方が、より効率。管理をしないと、目標達成の確率が下がります。目標を達成するためには、管理・監督が必須と言っても過言ではありません。",
    en: "It's not mandatory, but having management and oversight makes achieving your goals more efficient. Without management, the probability of achieving your goals decreases. It's no exaggeration to say that management and oversight are essential to achieving your goals.",
    cn: "並非必要，但為了達成目標，有管理與監督會更有效率。若不進行管理，達成目標的機率就會降低。說管理與監督是達成目標所必需的，一點也不為過。"
  },
  "有料サービスがありますか？": { jp: "有料サービスがありますか？", en: "Are there paid services?", cn: "有付費服務嗎？" },
  "excel.jpは、非営利団体ですので、無料でご利用いただけます。ただし、目的ではないですが、金融に関するコンサルが有料サービスもご用意しております。詳しくは、お問合せください。": {
    jp: "excel.jpは、非営利団体ですので、無料でご利用いただけます。ただし、目的ではないですが、金融に関するコンサルが有料サービスもご用意しております。詳しくは、お問合せください。",
    en: "excel.jp is a non-profit organization, so you can use it for free. However, although it's not our main purpose, we also offer paid financial consulting services. For details, please contact us.",
    cn: "excel.jp 是非營利組織，因此您可以免費使用。不過，雖然並非主要目的，我們也提供金融相關的付費諮詢服務。詳情請與我們聯繫。"
  },

  // Footer
  "プライバシーポリシー": { jp: "プライバシーポリシー", en: "Privacy Policy", cn: "隱私權政策" },
  "お問合せ": { jp: "お問合せ", en: "Contact Us", cn: "聯絡我們" },
  "サポート": { jp: "サポート", en: "Support", cn: "支援" },
  "EXCELについて": { jp: "EXCELについて", en: "About EXCEL", cn: "關於 EXCEL" },
  "データの削除": { jp: "データの削除", en: "Delete Data", cn: "刪除資料" },
  "児童安全 / CSAE": { jp: "児童安全 / CSAE", en: "Child Safety / CSAE", cn: "兒童安全 / CSAE" }
}
